<template>
    <div class="row">
        <div class="col-12 col-sm-6 col-md-4 mb-2">
            <div class="mb-1 is-required">
                {{ $t('email') }}:
            </div>

            <div>
                <input
                    class="form-control"
                    required
                    :value="invoice.email"
                    @input="onInput($event, 'email')"
                >
            </div>
        </div>

        <div class="col-12 col-sm-6 col-md-4 mb-2">
            <div class="mb-1 is-required">
                {{ $t('taxi.pages.summary.invoice.name') }}:
            </div>

            <div>
                <input
                    class="form-control"
                    required
                    :value="invoice.company"
                    @input="onInput($event, 'company')"
                >
            </div>
        </div>

        <div class="col-12 col-sm-6 col-md-4 mb-2">
            <div class="mb-1 is-required">
                {{ $t('vat_number') }}:
            </div>

            <div>
                <input
                    class="form-control"
                    required
                    :value="invoice.vat_number"
                    @input="onInput($event, 'vat_number')"
                >
            </div>
        </div>

        <div class="col-12 mb-2">
            <div class="mb-1 is-required">
                {{ $t('address') }}:
            </div>

            <div>
                <input
                    class="form-control"
                    required
                    :value="invoice.address"
                    @input="onInput($event, 'address')"
                >
            </div>
        </div>

        <div class="col-12 col-sm-6 col-md-3 mb-2">
            <div class="mb-1 is-required">
                {{ $t('zip') }}:
            </div>

            <div>
                <input
                    class="form-control"
                    required
                    :value="invoice.zip"
                    @input="onInput($event, 'zip')"
                >
            </div>
        </div>

        <div class="col-12 col-sm-6 col-md-5 mb-2">
            <div class="mb-1 is-required">
                {{ $t('city') }}:
            </div>

            <div>
                <input
                    class="form-control"
                    required
                    :value="invoice.city"
                    @input="onInput($event, 'city')"
                >
            </div>
        </div>

        <div class="col-12 col-sm-6 col-md-4 mb-2">
            <div class="mb-1 is-required">
                {{ $t('country') }}:
            </div>

            <div>
                <input
                    class="form-control"
                    required
                    :value="invoice.country"
                    @input="onInput($event, 'country')"
                >
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    import { updateClone } from '@utilities/object';

    export default {
        computed: {
            ...mapGetters({
                invoice: 'businessTaxi/getInvoice',
                userEmail: 'user/getEmail',
                userName: 'user/getName',
                userCompanyName: 'user/getCompanyName',
                userTaxNumber: 'user/getTaxNumber',
                userAddress: 'user/getAddress',
                userPostCode: 'user/getPostCode',
                userCountry: 'user/getCountry',
                userCity: 'user/getCity',
            }),
        },

        methods: {
            setFieldValue(field, value) {
                const invoice = updateClone(this.invoice, field, value);

                this.$store.dispatch('businessTaxi/setInvoice', invoice);
            },

            onInput(event, field) {
                this.setFieldValue(field, event.target.value);
            },
        },

        created() {
            if (!this.invoice.email && this.userEmail) {
                this.setFieldValue('email', this.userEmail);
            }

            if (!this.invoice.company && this.userCompanyName) {
                this.setFieldValue('company', this.userCompanyName);
            }

            if (!this.invoice.vat_number && this.userTaxNumber) {
                this.setFieldValue('vat_number', this.userTaxNumber);
            }

            if (!this.invoice.address && this.userAddress) {
                this.setFieldValue('address', this.userAddress);
            }

            if (!this.invoice.zip && this.userPostCode) {
                this.setFieldValue('zip', this.userPostCode);
            }

            if (!this.invoice.city && this.userCity) {
                this.setFieldValue('city', this.userCity);
            }

            if (!this.invoice.country && this.userCountry) {
                this.setFieldValue('country', this.userCountry);
            }
        },
    };
</script>
